import { Component, Output, EventEmitter, OnInit, Input, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Service } from './ctl-tms-demirbas-arama.service';
import { DxButtonModule } from 'devextreme-angular';
import { ColumnModel } from '@dabnet-kamu/libs/ui';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { DlistDto } from '@dabnet-kamu/libs/ui';
import { Observable } from 'rxjs';

import { OrtakService } from '@dabnet-kamu/libs/ui';
import { CommonModule } from '@angular/common';
import {TmsDemirbasService} from "../ctl-tms-demirbas.service";

@Component({
  selector: 'dk-ctl-tms-demirbas-arama',
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule],
  providers: [Service],
  templateUrl: './ctl-tms-demirbas-arama.component.html',
  styleUrls: ['./ctl-tms-demirbas-arama.component.scss'],
})
export class CtlTmsDemirbasAramaComponent implements OnInit   {
  private destroyRef = inject(DestroyRef);
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Input() control: any;
  @Output() private closePopup = new EventEmitter<string>();
  constructor(
    private service: Service,
    private tmsDemirbasService:TmsDemirbasService,
    public ortakService:OrtakService
  ) {

  }

  ngOnInit(): void {
    this.data = this.service.getData(this.control);
    this.gridControlsList$ = this.tmsDemirbasService.gridControlsList$;
    this.tmsDemirbasService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.closePopup.emit(e);
  }

  chooseBtnClick() {
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }
}

